import { AlertType, InboxAlertDto } from '@generatedTypes/data-contracts';
import { MissingMaterialAlertRow } from '@components/AlertCenter/AlertRows/inbox/MissingMaterialAlertRow';

export const InboxAlertRow = ({ alert }: { alert: InboxAlertDto }) => {
  if (alert.alertType === AlertType.MissingMaterial) {
    return <MissingMaterialAlertRow leadId={alert.leadId} />;
  }

  //eslint-disable-next-line
  console.error(`InboxAlertRow: alertType ${alert.alertType} is not supported`);

  return null;
};
